angular.module('eCareVault.common.userSelector', []);
